import { t } from "i18next"

export const getAmbienteOptions = () => ([
  { value: "PRODUCAO", label: t("fastfoodmobile.config.enum.ambiente.producao") },
  { value: "HOMOLOGACAO", label: t("fastfoodmobile.config.enum.ambiente.homologacao") },
  { value: "TESTE", label: t("fastfoodmobile.config.enum.ambiente.teste") }
])

export const getConexaoModoOptions = () => ([
  { value: "LOCAL", label: t("fastfoodmobile.config.enum.conexao-modo.local") },
  { value: "HTTPS_TUNNEL", label: t("fastfoodmobile.config.enum.conexao-modo.https-tunnel") },
  { value: "HIBRIDO", label: t("fastfoodmobile.config.enum.conexao-modo.hibrido") }
])

export const getConexaoPrioridadeOptions = () => ([
  { value: "LOCAL_PRIMEIRO", label: t("fastfoodmobile.config.enum.conexao-prioridade.local-primeiro") },
  { value: "HTTPS_TUNNEL_PRIMEIRO", label: t("fastfoodmobile.config.enum.conexao-prioridade.https-tunnel-primeiro") },
  { value: "SOMENTE_LOCAL", label: t("fastfoodmobile.config.enum.conexao-prioridade.somente-local") },
  { value: "SOMENTE_HTTPS_TUNNEL", label: t("fastfoodmobile.config.enum.conexao-prioridade.somente-https-tunnel") }
])

export const getProtocoloOptions = () => ([
  { value: "HTTP", label: t("fastfoodmobile.config.enum.protocolo.http") },
  { value: "HTTPS", label: t("fastfoodmobile.config.enum.protocolo.https") }
])

export const getTunnelProvedorOptions = () => ([
  { value: "CLOUDFLARE", label: t("fastfoodmobile.config.enum.tunnel-provedor.cloudflare") }
])

export const getAdquirenteOptions = () => ([
  { value: "NENHUMA", label: t("fastfoodmobile.config.enum.adquirente.nenhuma") },
  { value: "STONE", label: t("fastfoodmobile.config.enum.adquirente.stone") },
  { value: "PAGSEGURO", label: t("fastfoodmobile.config.enum.adquirente.pagseguro") },
  { value: "GETNET", label: t("fastfoodmobile.config.enum.adquirente.getnet") },
  { value: "REDE", label: t("fastfoodmobile.config.enum.adquirente.rede") },
  { value: "CIELO", label: t("fastfoodmobile.config.enum.adquirente.cielo") }
])

export const getModeloImpressaoOptions = () => ([
  { value: "ESC_POS", label: t("fastfoodmobile.config.enum.modelo-impressao.esc-pos") },
  { value: "SUNMI", label: t("fastfoodmobile.config.enum.modelo-impressao.sunmi") },
  { value: "POSITIVO_L3", label: t("fastfoodmobile.config.enum.modelo-impressao.positivo-l3") },
  { value: "OUTRO", label: t("fastfoodmobile.config.enum.modelo-impressao.outro") }
])

export const getSitefTipoIntegracaoOptions = () => ([
  { value: "NENHUMA", label: t("fastfoodmobile.config.enum.sitef-tipo-integracao.nenhuma") },
  { value: "M_SITEF", label: t("fastfoodmobile.config.enum.sitef-tipo-integracao.m-sitef") },
  { value: "CLISITEF_ANDROID", label: t("fastfoodmobile.config.enum.sitef-tipo-integracao.clisitef-android") },
  { value: "TAP_ON_PHONE", label: t("fastfoodmobile.config.enum.sitef-tipo-integracao.tap-on-phone") }
])
